import { Component } from '@angular/core';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-cp-reports-schedule-saving',
  templateUrl: './cp-reports-schedule-saving.component.html',
  styleUrl: './cp-reports-schedule-saving.component.scss'
})
export class CpReportsScheduleSavingComponent {

  report$ = this.energyReportsFacade.currentReport$.pipe(isDefined());

  viewModel$ = combineLatest({
    report: this.report$,
  });

  constructor(private energyReportsFacade: EnergyReportsFacade) {
  }
}
